import clsx from "clsx";
import { default as config } from "common/config/config";
import Balance from "ui/wallet/component/display/Balance/Balance";
import { BalanceProps } from "ui/wallet/component/display/Balance/Balance.types";
import useGetNearBalance from "features/wallet/hooks/useGetNearBalance";

export interface ResourceNearBalanceProps extends Omit<BalanceProps, "balance" | "isLoading" | "units"> {
    className?: string;
    style?: React.CSSProperties;
    resourceAddress: string;
}

export default function ResourceNearBalance({ className, resourceAddress, ...rest }: ResourceNearBalanceProps) {
    const { data: resourceNearBalance = "0", isLoading: isResourceNearBalanceLoading } = useGetNearBalance(resourceAddress);
    return (
        <>
            {resourceAddress.split(".")?.at(0) ?? ""}
            <Balance
                className={clsx("resource-near-balance", className)}
                balance={resourceNearBalance}
                isLoading={isResourceNearBalanceLoading}
                units={config.tokenNames.nativeToken}
                {...rest}
            />
        </>
    );
}
